module.exports = __webpack_public_path__ + "static/media/bg-newsletter.106c8341.svg";